(function () {
  function initStickyAtc() {
    const formElement = document.querySelector('.product-form__buttons--sticky');
    const addToCartButton = document.querySelector('.atc-sticky-scroll');

    if (!formElement || !addToCartButton) return;

    const setStickyState = (isSticky) => {
      formElement.classList.toggle('sticky_position', isSticky);
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const hasPassedViewport = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;

        setStickyState(hasPassedViewport);
      });

      observer.observe(addToCartButton);
      return;
    }

    let frameId = null;

    const updateStickyState = () => {
      frameId = null;
      setStickyState(addToCartButton.getBoundingClientRect().bottom <= 0);
    };

    const scheduleStickyUpdate = () => {
      if (frameId !== null) return;
      frameId = window.requestAnimationFrame(updateStickyState);
    };

    window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
    window.addEventListener('resize', scheduleStickyUpdate);
    scheduleStickyUpdate();
  }

  function initQuantitySync() {
    const quantityInputs = document.querySelectorAll('.js-qty__num');

    function syncQuantity(value, sourceInput) {
      quantityInputs.forEach((input) => {
        if (input !== sourceInput) input.value = value;
      });
    }

    quantityInputs.forEach((input) => {
      input.addEventListener('input', function () {
        syncQuantity(this.value, this);
      });
    });

    document.querySelectorAll('.js-qty__adjust').forEach((button) => {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        const input = this.closest('.js-qty__wrapper').querySelector('.js-qty__num');
        let value = parseInt(input.value) || 0;
        const minimum = parseInt(input.min) || 1;

        if (this.classList.contains('js-qty__adjust--plus')) value += 1;
        if (this.classList.contains('js-qty__adjust--minus') && value > minimum) value -= 1;

        input.value = value;
        syncQuantity(value, input);
      });
    });
  }

  function init() {
    initStickyAtc();
    initQuantitySync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
